/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Dialog, DialogActions,  DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { ENDPOINT } from '../../services/endPoints';
import useMasterApi from '../../services/useMasterApi';
import useToast from '../../hooks/useToast';
import CustomToast from '../../components/Toast/CustomToast';

const DetailCell = (props) => {
    const { row } = props;
    const [open, setOpen] = useState(false)
  const { put: formViewed, data: formViewData, error } = useMasterApi();
  const { toastMessage, toast, toastType, setToast, showToast } = useToast()
  const navigate = useNavigate();

  const hospitalId = localStorage.getItem("hospitalId");

  function handleFormView(){
    if ((Object.keys(row).length) && row?.form_viewed !== "1" && hospitalId === row?.hospital_id) {
      formViewed(`${ENDPOINT.FORM_VIEWED}/${row?.form_code}`, { form_viewed: "1", form_type: row?.form_type })
    }
  }
   
    const handleClickOpen = () => {
      row.form_viewed !== "1" && hospitalId === row?.hospital_id ? setOpen(true) : navigate(`/referred-pateint-list/users/record_detail_form/${row.pf_id}`, {state: {formType: row.form_type, form_code: row.form_code, form_viewed: row.form_viewed}})
  };

  const handleClose = () => {
      setOpen(false);
  };

  const handleAccept = () => {
      handleFormView()
      handleClose()
  };

  const handleReject = () => {
    handleClose();
  };

  useEffect(()=>{
    if(formViewData.success){
      showToast("success", "Form Viewed Successfully")
      navigate(`/referred-pateint-list/users/record_detail_form/${row.pf_id}`, {state: {formType: row.form_type, form_code: row.form_code, form_viewed: row.form_viewed}})
    }

    if(error){
      showToast("error", "Error Viewing Form")
    }

  },[formViewData, error])

  return (
    <>
    <Button size='small' onClick={handleClickOpen} color="primary" sx={{fontSize: "10px", textWrap:"nowrap"}}>Details</Button>

    <Dialog open={open} onClose={handleClose} fullWidth>
                <DialogTitle>Are you sure you want to view this patient's test?
                    <IconButton style={{ position: 'absolute', right: '8px', top: '8px' }} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton></DialogTitle>
                <DialogActions>
                    <Button onClick={handleReject} color="primary"  >
                        No
                    </Button>
                    <Button onClick={handleAccept} color="primary" >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            {toast && <CustomToast 
        open={toast}
        toastMessage={toastMessage}
        setToast={setToast}
        toastType={toastType}
      />}
    </>
  )
}

export default DetailCell